import { Client } from './client_server.js'
import * as utils from './utils'
const objectPath = require('object-path')
import axios from 'axios'
axios.defaults.withCredentials = false

let g_parent = new Client('widget_4_parent', window.parent)

const post = (url, body, options) =>
	g_parent.call('fetch', 'post', url, body, options)

const get = (url, options) => g_parent.call('fetch', 'get', url, options)

export const sendBatchRequest = async (batchName, ops) => {
	const resp = await post('/batch2/' + batchName, { ops })
	return resp.data
}

export const listConversations = async (
	mask,
	accountId,
	userId,
	options = {}
) => {
	const params = Object.assign({}, options, {
		user_id: userId,
		'x-user-mask': mask,
		integration_id: utils.getIntegrationId(accountId),
	})

	const resp = await get('/conversations', { params })
	return resp.data
}

export const getMessages = async (
	mask,
	accountId,
	convoId,
	limit,
	options = {}
) => {
	const params = Object.assign({ 'x-user-mask': mask }, options, { limit })
	const resp = await get(`/conversations/${convoId}/messages`, { params })
	return resp.data
}

export const start = async (
	mask,
	accountId,
	userId,
	extraData = {},
	convoId
) => {
	const data = {
		starter_id: userId,
		starter_type: 'user',
		integration_id: utils.getIntegrationId(accountId),
	}

	for (let key in extraData) {
		data[key] = extraData[key]
	}

	const options = { params: { 'x-user-mask': mask } }

	if (convoId) {
		const resp = await post(
			`/conversations/${convoId}`,
			{ request: data, state: 'active' },
			options
		)
		return resp.data
	}
	const resp = await post(`/conversations`, data, options)
	return resp.data
}

export const sendMessage = async (mask, accountId, convoId, data) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(`/conversations/${convoId}/messages`, data, options)
	return resp.data
}

export const end = async (mask, accid, cid) => {
	const options = { params: { 'x-user-mask': mask } }
	return await post(`/conversations/${cid}/ended`, null, options)
}

export const ackMessage = async (mask, accountId, convoId, messageId) => {
	const options = { params: { 'x-user-mask': mask } }
	const path = `/conversations/${convoId}/messages/${messageId}/ack`
	const resp = await post(path, null, options)
	return resp.data
}

export const markAsReceived = async (mask, accountId, convoId, messageId) => {
	const options = { params: { 'x-user-mask': mask } }
	const path = `/conversations/${convoId}/messages/${messageId}/receive`
	const resp = await post(path, null, options)
	return resp.data
}

export const markAsSeen = async (mask, accountId, convoId, messageId) => {
	const options = { params: { 'x-user-mask': mask } }
	const path = `/conversations/${convoId}/messages/${messageId}/seen`
	const resp = await post(path, null, options)
	return resp.data
}

export const getConversation = async (mask, accountId, convoId) => {
	if (!convoId) return {}
	const options = { params: { 'x-user-mask': mask } }
	const resp = await get(`/conversations/${convoId}`, options)
	return resp.data
}

export const sendEvent = async (mask, accountId, userId, data) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(`/users/${userId}/events`, data, options)
	return resp.data
}

export const sendTyping = async (mask, convoId) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(`/conversations/${convoId}/typing`, null, options)
	return resp.data
}

export const sendPresence = (mask, accountId, userId, device) => {
	const event = {
		by: { id: userId, device: device },
		type: 'presence_updated',
		object: 'presence',
		data: { presence: { pinged: +new Date() } },
	}

	return sendEvent(mask, accountId, userId, event)
}

export const sendContent = (
	mask,
	accountId,
	userId,
	device,
	pageUrl,
	pageTitle
) => {
	const event = {
		by: { id: userId, device: device },
		type: 'content_viewed',
		object: 'content',
		data: { content: { url: pageUrl, title: pageTitle } },
	}

	return sendEvent(mask, accountId, userId, event)
}

const presign = async (mask, accid, file) => {
	const data = {
		account_id: accid,
		name: file.name,
		size: file.size,
		type: file.type,
	}

	const resp = await post(`/accounts/${accid}/files`, data)
	return resp.data
}

export const uploadToS3 = async (mask, accid, files) => {
	let result = []

	for (let file of files) {
		const presignResponse = await presign(mask, accid, file)
		const uploadResponse = await axios.put(presignResponse.signed_url, file, {
			withCredentials: false,
			headers: { 'Content-Type': file.type },
		})

		if (uploadResponse.status === 200) {
			let path = `/accounts/${accid}/files/${presignResponse.id}`
			const changeAclResponse = await post(path, { account_id: accid })
			result.push(changeAclResponse.data)
		}
	}

	return result
}

export const recordDomain = params =>
	get(`${process.env.VUE_APP_BACKEND_URL}/v4/pageview`, { params })

export const updateFcmToken = async (mask, token) => {
	const options = { params: { 'x-user-mask': mask } }
	try {
		const resp = await post(
			`/notification-tokens/${token}`,
			{ platform: 'desktop' },
			options
		)
		return resp.data
	} catch (err) {
		if (err.response) return { error: err.response.data }
		return { error500: err.message }
	}
}

export const deleteFcmToken = async (mask, token) => {
	const options = { params: { 'x-user-mask': mask } }
	try {
		const resp = await post(
			`/notification-tokens/${token}/delete`,
			null,
			options
		)
		return resp.data
	} catch (err) {
		if (err.response) return { error: err.response.data }
		return { error500: err.message }
	}
}

const loadCreateUser = () =>
	import(/* webpackChunkName: "create-user" */ './create_user.js')

const getChallenge = async accid => {
	const resp = await post(`/accounts/${accid}/scrypt-challenges`)
	return resp.data
}

export const getUser = async (accountId, userId) => {
	const resp = await get(`/users/${userId}`)
	return resp.data
}

export const createUser = async accountId => {
	let CU = await loadCreateUser()

	let created = false
	let user = {}
	let count = 0

	while (!created && count < 10) {
		count++
		const challenge = await getChallenge(accountId)
		utils.log('challenge', challenge)

		const answer = await CU.findAnswer(challenge)
		utils.log('answer', answer)

		const data = { challenge_id: challenge.id, answer: '' + answer }

		let resp
		try {
			resp = await post(`/accounts/${accountId}/scrypt-challenges/users`, data)
			// const resp = { error: 'wrong_answer' }
		} catch (error) {
			const code = objectPath.get(error, 'response.data.error', '')
			if (code === 'wrong_answer') {
				utils.log('wrong answer: get new challenge')
				await utils.sleep(1000)
				continue
			}

			throw error
		}

		user = resp.data
		created = true
	}

	return user
}

export const updateUser = async (mask, accountId, userId, data) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(`/users/${userId}`, data, options)
	return resp.data
}

export const getGeoIP = async () => {
	const resp = await get(`${process.env.VUE_APP_BACKEND_URL}/v4/geoip`)
	return resp.data
}

export const getUserSetting = async (mask, accountId, userId) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await get(`/accounts/${accountId}/widgets/${userId}`, options)
	return resp.data
}

export const updateUserSetting = async (mask, accountId, userId, setting) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(
		`/accounts/${accountId}/widgets/${userId}`,
		setting,
		options
	)
	return resp.data
}

export const getAccountSetting = async accountId => {
	const resp = await get(`/accounts/${accountId}/widgets`)
	return resp.data
}

export const subscribe = async (mask, accountId, connectionId, events) => {
	const options = { params: { 'x-user-mask': mask } }
	const resp = await post(
		`/accounts/${accountId}/ws/${connectionId}/events`,
		{ events },
		options
	)
	return resp.data
}
